module.exports = __webpack_public_path__ + "assets/5d29e1b0b52377655fb6af318d2a5e77.png";